export default __webpack_public_path__ + "static/logo-blk-2f43b443e61770fde95320dede0c9942.webp";